import React from "react";

const FacebookIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M9.9375 9.25H7.875V12H9.9375V20.25H13.375V12H15.8789L16.125 9.25H13.375V8.10394C13.375 7.44738 13.507 7.1875 14.1416 7.1875H16.125V3.75H13.507C11.0348 3.75 9.9375 4.83831 9.9375 6.92281V9.25Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="16.5"
            height="16.5"
            fill="white"
            transform="translate(3.75 3.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FacebookIcon;
